// Utilidades para procesar imágenes en el navegador (subidas del usuario).
// Convierte un archivo de imagen en una miniatura JPEG (data URL) para guardarla
// en el catálogo sin inflar el tamaño ni depender de almacenamiento externo.

export const fileToThumb = (
  file: File,
  max = 480,
  quality = 0.78
): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        try {
          const scale = Math.min(1, max / Math.max(img.width, img.height));
          const canvas = document.createElement("canvas");
          canvas.width = Math.max(1, Math.round(img.width * scale));
          canvas.height = Math.max(1, Math.round(img.height * scale));
          const ctx = canvas.getContext("2d");
          if (!ctx) return resolve(String(reader.result));
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL("image/jpeg", quality));
        } catch {
          resolve(String(reader.result));
        }
      };
      img.onerror = () => reject(new Error("No se pudo leer la imagen."));
      img.src = String(reader.result);
    };
    reader.onerror = () => reject(new Error("No se pudo leer el archivo."));
    reader.readAsDataURL(file);
  });